import { PLAN_IDS, PLAN_RANK, type PlanDto, type PlanId } from "@workcost/shared";

export type { PlanId };
export { PLAN_IDS, PLAN_RANK };

/** แพ็กเกจที่ซื้อได้ (ไม่รวม free) */
export const PAID_PLAN_IDS = ["basic", "standard", "premium"] as const satisfies readonly PlanId[];
export type PaidPlanId = (typeof PAID_PLAN_IDS)[number];

/** แพ็กเกจที่แนะนำตาม brief (ไม่อยู่ในข้อมูลจาก API) */
export const RECOMMENDED_PLAN: PlanId = "standard";

export const isPlanId = (v: string | undefined): v is PlanId => !!v && (PLAN_IDS as readonly string[]).includes(v);
export const isPaidPlan = (v: string | undefined): v is PaidPlanId => !!v && (PAID_PLAN_IDS as readonly string[]).includes(v);

/**
 * มุมมองแพ็กเกจสำหรับแสดงผล ได้จาก GET /plans (PlanDto) เท่านั้น
 * สิทธิ์จริงตรวจฝั่ง server เสมอ ห้ามใช้ค่านี้ตัดสินสิทธิ์
 */
export interface PlanView {
  id: PlanId;
  price: number;
  estimates: number;
  /** null = ไม่จำกัด */
  savedJobs: number | null;
  quote: boolean;
  recommended: boolean;
}

export function toPlanView(d: PlanDto): PlanView {
  return { id: d.plan, price: d.price_thb, estimates: d.estimates_per_month, savedJobs: d.saved_jobs_limit, quote: d.quotation, recommended: d.plan === RECOMMENDED_PLAN };
}

/** เรียงตามระดับแพ็กเกจ Free ถึง Premium */
export function sortPlans(items: readonly PlanDto[]): PlanView[] {
  return items.map(toPlanView).sort((a, b) => PLAN_RANK[a.id] - PLAN_RANK[b.id]);
}

/** ซื้อแพ็กเกจนี้ไม่ได้เพราะต่ำกว่าที่ใช้อยู่ (server ตรวจซ้ำและตอบ 409 downgrade_blocked) */
export const isLowerThan = (target: PlanId, current: PlanId): boolean => PLAN_RANK[target] < PLAN_RANK[current];
